import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { BadgePayload, BadgesType } from '~/entities/badges/model/types'

export class BadgesServices {
  static getBadges(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<BadgesType[]>> {
    return apiService.get<AxiosResponse<BadgesType[]>>('/badges', config)
  }

  static getBadgeById(id: string): Promise<AxiosResponse<BadgesType>> {
    return apiService.get<AxiosResponse<BadgesType>>(`/badges/${id}`)
  }

  static createBadge(data: BadgePayload): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/badges', data)
  }

  static updateBadge = (id: string, data: BadgePayload) => {
    return apiService.put<AxiosResponse<BadgesType>>(`/badges/${id}`, data)
  }

  static removeBadge(id: string) {
    return apiService.delete(`/badges/${id}`)
  }
}
